var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "auto",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.707 7.62a1 1 0 0 0-1.414 0l-3.705 3.704a.831.831 0 0 0 1.175 1.177L10 9.27l3.237 3.23a.831.831 0 0 0 1.175-1.177L10.707 7.62Z",
    fill: "current"
  })));
};
export default SvgChevronUp;